import React, { useState } from "react";
import "./homeappointment.css";

/**
 * Dynamically load Razorpay SDK
 */
function loadRazorpayScript() {
  return new Promise((resolve) => {
    if (window.Razorpay) return resolve(true);
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
} 

// ✅ Services with prices
const SERVICES = {
  kundlianalysis: { label: "Full Kundli Analysis (30 MINS)", originalPrice: 1100, offerPrice: 770 },
  kundlianalysisUrgent: { label: "Full Kundli Analysis (1 HR)", originalPrice: 2200, offerPrice: 1540 },
  lovelife30: { label: "Relationship & Marriage Consultation (30 MINS)", originalPrice: 799, offerPrice: 560 },
  lovelife60: { label: "Relationship & Marriage Consultation (1 HR)", originalPrice: 1499, offerPrice: 1120 },
  career30: { label: "Career Guidance Consultation (30 MINS)", originalPrice: 799, offerPrice: 560 },
  career60: { label: "Career Guidance Consultation (1 HR)", originalPrice: 1499, offerPrice: 1120 },
  Quickconsultation: { label: "Quick Consultation (10 MINS)", originalPrice: 500, offerPrice: 350 },
  TimeRectification: { label: "Time Rectification + Full Kundli Analysis", originalPrice: 2700, offerPrice: 1890 },
  CoupleConsultation: { label: "Couple Consultation (Compatibility Matching)", originalPrice: 3000, offerPrice: 2100 },
};

const BACKEND_URL = "https://cosmicalcalculatorbackend.onrender.com";

export default function HomeAppointment() {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    service: "",
    date: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  }

  const selectedServicePrice = form.service ? SERVICES[form.service].offerPrice : 0;

 async function handlePay(e) {
  e.preventDefault();
  setMessage(null);

  if (!form.firstName || !form.lastName || !form.email || !form.phone || !form.date || !form.service) {
    setMessage({ type: "error", text: "Please fill all fields properly." });
    return;
  }

  setLoading(true);

  try {
    const createResp = await fetch(`${BACKEND_URL}/create-order`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        form,
        service: SERVICES[form.service].label,
        amount: selectedServicePrice,
      }),
    });

    const data = await createResp.json();
    if (!createResp.ok) {
      setMessage({ type: "error", text: data.error || "Failed to create order." });
      setLoading(false);
      return;
    }

    // ✅ Create and submit hidden PayU form
    const formEl = document.createElement("form");
    formEl.method = "POST";
    formEl.action = data.action;

    Object.entries(data).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      formEl.appendChild(input);
    });

    document.body.appendChild(formEl);
    formEl.submit();
  } catch (err) {
    console.error(err);
    setMessage({ type: "error", text: "Something went wrong. Try again." });
    setLoading(false);
  }
}



  return (
    <section className="appointment-wrap-homeappointment">
      <div className="appointment-grid-homeappointment">

        {/* ===== Left Section ===== */}
        <div className="appointment-left-homeappointment">
          <div className="small-label-homeappointment">Appointment</div>
          <h1 className="hero-heading-homeappointment">
            <span className="line-homeappointment">BOOK</span>
            <span className="line-homeappointment">YOUR</span>
            <span className="line-homeappointment">PERSONALIZED</span>
            <span className="line-homeappointment">CONSULTATION</span>
          </h1>
        </div>

        {/* ===== Right Form Section ===== */}
        <div className="appointment-form-homeappointment">
          <form noValidate onSubmit={handlePay}>
            <div className="form-grid-homeappointment">
              
              {/* Fields */}
              <div className="form-field-homeappointment">
                <label className="form-label-homeappointment" htmlFor="firstName">FIRST NAME*</label>
                <input
                  id="firstName"
                  name="firstName"
                  className="form-input-homeappointment"
                  placeholder="Enter Your First Name"
                  value={form.firstName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field-homeappointment">
                <label className="form-label-homeappointment" htmlFor="lastName">LAST NAME*</label>
                <input
                  id="lastName"
                  name="lastName"
                  className="form-input-homeappointment"
                  placeholder="Enter Your Last Name"
                  value={form.lastName}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field-homeappointment">
                <label className="form-label-homeappointment" htmlFor="phone">YOUR PHONE*</label>
                <input
                  id="phone"
                  name="phone"
                  className="form-input-homeappointment"
                  placeholder="+91 98xxxxxxx"
                  value={form.phone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-field-homeappointment">
                <label className="form-label-homeappointment" htmlFor="email">YOUR EMAIL*</label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  className="form-input-homeappointment"
                  placeholder="youremail@domain.com"
                  value={form.email}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* ===== Dropdown ===== */}
              <div className="form-field-homeappointment full-width">
                <label className="form-label-homeappointment" htmlFor="service">SERVICES*</label>
                <div
                  className="custom-dropdown"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                >
                  <div className="selected-option">
                    {form.service ? (
                      <>
                        <span>{SERVICES[form.service].label}</span>
                        <div>
                          <span className="original-price-homeappointment">
                            ₹{SERVICES[form.service].originalPrice}
                          </span>
                          <span className="offer-price-homeappointment">
                            ₹{SERVICES[form.service].offerPrice}
                          </span>
                        </div>
                      </>
                    ) : (
                      <span>Choose service</span>
                    )}
                  </div>
                  {dropdownOpen && (
                    <div className="dropdown-options-homeappointment">
                      {Object.entries(SERVICES).map(([key, { label, originalPrice, offerPrice }]) => (
                        <div
                          key={key}
                          className="dropdown-option"
                          onClick={() => {
                            setForm({ ...form, service: key });
                            setDropdownOpen(false);
                          }}
                        >
                          <span>{label}</span>
                          <div>
                            <span className="original-price-homeappointment">₹{originalPrice}</span>
                            <span className="offer-price-homeappointment">₹{offerPrice}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>

              {/* ===== Date ===== */}
              {/* <div className="form-field-homeappointment full-width">
                <label className="form-label-homeappointment" htmlFor="date">DATE*</label>
                <input
                  id="date"
                  name="date"
                  type="date"
                  className="form-date-homeappointment"
                  value={form.date}
                  onChange={handleChange}
                  required
                />
              </div> */}

              {/* ===== Button ===== */}
              <div className="form-actions-homeappointment">
                <button
                  type="submit"
                  className="btn-book-homeappointment"
                  disabled={!form.service || loading}
                >
                  {loading ? "Processing..." : `Pay ₹${selectedServicePrice} & Book`}
                </button>
                {message && (
                  <p
                    className={`message-homeappointment ${
                      message.type === "error" ? "error" : "success"
                    }`}
                  >
                    {message.text}
                  </p>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
